import { Record } from "immutable";

export interface IFeneTechListQuoteData {
  oKey: number;
  orderNumber: string;
  poNumber: string;
  customerRef: string;
  webCenterCustomerName: string;
}

export interface IFeneTechListQuoteRecord extends IFeneTechListQuoteData {}

const defaultFeneTechListQuoteProps: IFeneTechListQuoteRecord = {
  oKey: 0,
  orderNumber: "",
  poNumber: "",
  customerRef: "",
  webCenterCustomerName: "",
};

export class FeneTechListQuoteRecord
  extends Record(defaultFeneTechListQuoteProps)
  implements IFeneTechListQuoteRecord {}

export const feneTechListQuoteFromJSON = (json: IFeneTechListQuoteData): FeneTechListQuoteRecord =>
  new FeneTechListQuoteRecord({ ...json });
